<script>
  import { createEventDispatcher, onMount } from "svelte";
  import chroma from "chroma-js";

  export let redVal, blueVal, greenVal, alphaVal, hexColor, key, colorStopVal;
  export let hasColorStop = undefined; // is there needs to color stop?
  export let dispatchOnInit = undefined; // is there need to dispatch the color on component initialisation ?
  let showColorStop = false;
  let redInputVal,
    blueInputVal,
    greenInputVal,
    alphaInputVal,
    colorStopInputVal,
    showColorStopInputVal;
  let colVal = `rgba(${redVal},${greenVal},${blueVal},${alphaVal})`;

  const updateColorStop = () => {
    colorStopVal = colorStopInputVal.value;
  };
  const updateColor = () => {
    redVal = redInputVal.value;
    greenVal = greenInputVal.value;
    blueVal = blueInputVal.value;
    alphaVal = alphaInputVal.value;
    colVal = `rgba(${redInputVal.value},${greenInputVal.value},${blueInputVal.value},${alphaInputVal.value})`;
    hexColor = chroma(colVal).hex();
  };
  const dispatch = createEventDispatcher();

  onMount(() => {
    if (hexColor !== undefined) {
      console.log("the HEXX", hexColor);
      let obj = chroma(hexColor);
      redVal = obj.get("rgba.r");
      greenVal = obj.get("rgba.g");
      blueVal = obj.get("rgba.b");
      alphaVal = obj.get("rgba.a");
      colVal = chroma(hexColor).css();
    } else {
      hexColor = chroma(colVal).hex();
    }
    if (dispatchOnInit !== undefined) {
      //fire the color change event to the interrested parties
      dispatch("colorChanged", {
        key: key,
        rgbaColor: colVal,
        hexColor: hexColor,
      });
    }
  });
  const sendColorData = () => {
    updateColor();
    // console.log("HHHH", hexColor);
    dispatch("colorChanged", {
      key: key,
      rgbaColor: colVal,
      hexColor: hexColor,
    });
  };
  const sendColorStopData = () => {
    updateColorStop();
    dispatch("colorStopChanged", {
      key: key,
      colorStop: colorStopVal,
    });
  };
</script>

<div
  id="mixer"
  style="box-shadow: {hexColor} 3px 2px 3px 2px, {hexColor} 0px 4px 6px -4px, {hexColor} 3px 1px 3px inset;"
>
  <span
    style="display: inline-block; font-size:12px ; color: #000 ; backgroung-color:#fff ; border-top : 3px solid {hexColor};border-bottom : 3px solid {hexColor}; margin :auto;"
    >{hexColor}</span
  >
  <div id="color-viewer" style="background-color: {colVal};" />
  <div class="color-input">
    <span class="color-marker">R</span>
    <input
      type="range"
      on:change={sendColorData}
      on:input={sendColorData}
      id="red"
      bind:this={redInputVal}
      min="0"
      max="255"
      value={redVal}
      style="background-color: red;"
    />

    <span class="color-marker"
      >{redInputVal === undefined ? redVal : redInputVal.value}</span
    >
  </div>

  <div class="color-input">
    <span class="color-marker">G</span>
    <input
      type="range"
      on:change={sendColorData}
      on:input={sendColorData}
      id="green"
      bind:this={greenInputVal}
      min="0"
      max="255"
      value={greenVal}
      style="background-color: green;"
    />
    <span class="color-marker"
      >{greenInputVal === undefined ? greenVal : greenInputVal.value}</span
    >
  </div>

  <div class="color-input">
    <span class="color-marker">B</span>
    <input
      type="range"
      on:change={sendColorData}
      on:input={sendColorData}
      id="blue"
      bind:this={blueInputVal}
      min="0"
      max="255"
      value={blueVal}
      style="background-color: blue;"
    />
    <span class="color-marker"
      >{blueInputVal === undefined ? blueVal : blueInputVal.value}</span
    >
  </div>

  <div class="color-input">
    <span class="color-marker">A</span>
    <input
      type="range"
      on:change={sendColorData}
      on:input={sendColorData}
      id="alpha"
      bind:this={alphaInputVal}
      min="0"
      max="1"
      step="0.1"
      value={alphaVal === undefined ? 1 : alphaVal}
    />
    <span class="color-marker"
      >{alphaInputVal === undefined ? alphaVal : alphaInputVal.value}</span
    >
  </div>

  {#if hasColorStop !== undefined}
    <div id="color-stops">
      <div style="display:flex;flex-direction:row">
        <span class="color-marker"> C.S</span>
        <input
          type="checkbox"
          bind:this={showColorStopInputVal}
          on:change={() => {
            showColorStop = showColorStopInputVal.checked;
            // showColorStopInputVal.checked === "checked" ? true : false;
          }}
          checked={showColorStop}
        />
      </div>
      {#if showColorStop}
        <div style="display:flex;flex-direction:row">
          <input
            type="range"
            on:change={sendColorStopData}
            on:input={sendColorStopData}
            id="colorstop"
            bind:this={colorStopInputVal}
            min="0"
            max="100"
            value={colorStopVal.toString()}
            style="background-color: {hexColor};"
          />
          <span class="color-marker">{colorStopVal}%</span>
        </div>
      {/if}
    </div>
  {/if}
</div>

<style>
  #mixer {
    display: flex;
    flex-direction: column;
    width: 140px;
    border: 1px solid;
    border-radius: 16px;
    padding: 8px;
  }
  #color-viewer {
    width: 100%;
    height: 40px;
    margin: 3px;
    border-radius: 12px;
  }
  .color-input {
    display: flex;
    flex-direction: row;
  }
  .color-marker {
    font-size: 15px;
    font-weight: bold;
  }
  input[type="range"] {
    -webkit-appearance: none;
    width: 100%;
    border-radius: 8px;
    height: 7px;
    border: 1px solid #bdc3c7;
  }
</style>
